import React from 'react';
import { useGlobalStore } from '../../../application/store/store';
import { Box, TextField } from '@mui/material';
interface NoteProps {
    label?: string;
}

const Note: React.FC<NoteProps> = ({ label = 'Anteckning' }) => {
    const note = useGlobalStore((state) => state.note);
    const setNote = useGlobalStore((state) => state.setNote);

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setNote(e.target.value);
    };

    return (
        <Box sx={{ width: '100%', textAlign: 'center', px: { xs: 2, sm: 0 } }}>
            <TextField
                id="note"
                label={label}
                multiline
                rows={4}
                fullWidth
                variant="outlined"
                value={note}
                onChange={handleChange}
                aria-label="Skriv din kommentar här"
                aria-required="true"
                aria-describedby="note-description"
            />
        </Box>
    );
};

export default Note;
